import React, { useState, useEffect } from 'react';
import TableMenu from './TableMenu';
import {
	FormControl,
	Box,
	TextField,
	Autocomplete,
	Checkbox,
	ThemeProvider,
	Chip,
	Paper,
	Button,
	Stack,
} from '@mui/material';
import { CheckBoxOutlineBlank, CheckBox, Clear } from '@mui/icons-material';
import { theme } from '../../../theme/theme';
import { useSelector, useDispatch } from 'react-redux';
import {
	setBreakdownByFilterAction,
	setViewByFilterAction,
	setTimePeriodAction,
	setNewTimePeriodAction,
} from '../../../redux/actions/tableActions';
import { saveEventTrack } from '../../../redux/actions/eventTrackAction';
import { UserPortalContext } from '../../../context/appcontext';

import analytics from '../../../helper/analytics';
import tracker from '../../../constants/tracker';

import {
	WMT_ATTR,
	DEPARTMENT,
	CATEGORY,
	SUBCATEGORY,
	ITEM,
	BRAND,
	STATE,
	STORE,
	COMPARISON_TIME_PERIOD,
	LAST_WMT_WEEK,
	LAST_4_WMT_WEEK,
	LAST_13_WMT_WEEK,
	LAST_26_WMT_WEEK,
	LAST_52_WMT_WEEK,
	LAST_WMT_WEEK_SHORT,
	LAST_4_WMT_WEEK_SHORT,
	LAST_13_WMT_WEEK_SHORT,
	LAST_26_WMT_WEEK_SHORT,
	LAST_52_WMT_WEEK_SHORT,
	SET_TO_DEFAULT,
	SELECT_ONE_OR_MULTIPLE,
	VIEWBY_ENUMS,
	TIME_PERIOD_ENUMS,
	CUSTOM_ATTR,
	MAIN_INSIGHTS_DASHBOARD,
	CUSTOM_ATTRIBUTE,
	WALMART_ATTRIBUTE,
	FINELINE,
	SUB_DIVISION,
	REGION,
	MARKET,
	PRIME_ITEM_NUMBER,
	ALL_LINK_NUMBER,
} from '../../../constants/constant';
import { useStyles } from './styles';
import { FormLabel } from '@material-ui/core';
import CustomTableColumn from '../../CustomTableColumn/CustomTableColumn';
import { colors } from '../../../theme/color-palette';
const { PURPLE } = colors;

const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBox fontSize="small" />;

let viewByOptions = [
	{ value: VIEWBY_ENUMS.DEPARTMENT, label: DEPARTMENT },
	{ value: VIEWBY_ENUMS.CATEGORY, label: CATEGORY },
	{ value: VIEWBY_ENUMS.SUBCATEGORY, label: SUBCATEGORY },
	{ value: VIEWBY_ENUMS.ITEM, label: ITEM },
	{ value: VIEWBY_ENUMS.BRAND, label: BRAND },
	{ value: VIEWBY_ENUMS.ALL_LINK_NUMBER, label: ALL_LINK_NUMBER },
	{ value: VIEWBY_ENUMS.PRIME_ITEM_NUMBER, label: PRIME_ITEM_NUMBER },
];

const viewByOptions_omni_ecom = [
	{ value: VIEWBY_ENUMS.DEPARTMENT, label: DEPARTMENT },
	{ value: VIEWBY_ENUMS.CATEGORY, label: CATEGORY },
	{ value: VIEWBY_ENUMS.SUBCATEGORY, label: SUBCATEGORY },
	{ value: VIEWBY_ENUMS.ITEM, label: ITEM },
	{ value: VIEWBY_ENUMS.BRAND, label: BRAND },
	{ value: VIEWBY_ENUMS.PRIME_ITEM_NUMBER, label: PRIME_ITEM_NUMBER},
	{ value: VIEWBY_ENUMS.ALL_LINK_NUMBER, label: ALL_LINK_NUMBER },
];

const viewByOptions_store = [
	{ value: VIEWBY_ENUMS.DEPARTMENT, label: DEPARTMENT },
	{ value: VIEWBY_ENUMS.CATEGORY, label: CATEGORY },
	{ value: VIEWBY_ENUMS.SUBCATEGORY, label: SUBCATEGORY },
	{ value: VIEWBY_ENUMS.ITEM, label: ITEM },
	{ value: VIEWBY_ENUMS.BRAND, label: BRAND },
	{ value: VIEWBY_ENUMS.STORE, label: STORE },
	{ value: VIEWBY_ENUMS.STATE, label: STATE },
	{ value: VIEWBY_ENUMS.FINELINE, label: FINELINE },
	{ value: VIEWBY_ENUMS.ALL_LINK_NUMBER, label: ALL_LINK_NUMBER },
	{ value: VIEWBY_ENUMS.PRIME_ITEM_NUMBER, label: PRIME_ITEM_NUMBER },
	{ value: VIEWBY_ENUMS.SUB_DIVISION, label: SUB_DIVISION },
	{ value: VIEWBY_ENUMS.REGION, label: REGION },
	{ value: VIEWBY_ENUMS.MARKET, label: MARKET },
];

const breakDownByOptions_DEPARTMENT = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
	{ value: VIEWBY_ENUMS.CATEGORY, label: CATEGORY },
	{ value: VIEWBY_ENUMS.SUBCATEGORY, label: SUBCATEGORY },
	{ value: VIEWBY_ENUMS.ITEM, label: ITEM },
	{ value: VIEWBY_ENUMS.BRAND, label: BRAND },
	{ value: VIEWBY_ENUMS.ALL_LINK_NUMBER, label: ALL_LINK_NUMBER },
	{ value: VIEWBY_ENUMS.PRIME_ITEM_NUMBER, label: PRIME_ITEM_NUMBER },
];

const breakDownByOptions_ALL_LINK_NUMBER = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
	{ value: VIEWBY_ENUMS.ITEM, label: ITEM },
];

const breakDownByOptions_PRIME_ITEM_NUMBER = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
	{ value: VIEWBY_ENUMS.ITEM, label: ITEM },
];

const breakDownByOptions_store_DEPARTMENT = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
	{ value: VIEWBY_ENUMS.CATEGORY, label: CATEGORY },
	{ value: VIEWBY_ENUMS.SUBCATEGORY, label: SUBCATEGORY },
	{ value: VIEWBY_ENUMS.ITEM, label: ITEM },
	{ value: VIEWBY_ENUMS.BRAND, label: BRAND },
	{ value: VIEWBY_ENUMS.STATE, label: STATE },
	{ value: VIEWBY_ENUMS.STORE, label: STORE },
	{ value: VIEWBY_ENUMS.FINELINE, label: FINELINE },
	{ value: VIEWBY_ENUMS.ALL_LINK_NUMBER, label: ALL_LINK_NUMBER },
	{ value: VIEWBY_ENUMS.PRIME_ITEM_NUMBER, label: PRIME_ITEM_NUMBER },
	{ value: VIEWBY_ENUMS.SUB_DIVISION, label: SUB_DIVISION },
	{ value: VIEWBY_ENUMS.REGION, label: REGION },
	{ value: VIEWBY_ENUMS.MARKET, label: MARKET },

];

const breakDownByOptions_CATEGORY = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
	{ value: VIEWBY_ENUMS.SUBCATEGORY, label: SUBCATEGORY },
	{ value: VIEWBY_ENUMS.ITEM, label: ITEM },
	{ value: VIEWBY_ENUMS.BRAND, label: BRAND },
	{ value: VIEWBY_ENUMS.ALL_LINK_NUMBER, label: ALL_LINK_NUMBER },
	{ value: VIEWBY_ENUMS.PRIME_ITEM_NUMBER, label: PRIME_ITEM_NUMBER },
];

const breakDownByOptions_store_CATEGORY = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
	{ value: VIEWBY_ENUMS.SUBCATEGORY, label: SUBCATEGORY },
	{ value: VIEWBY_ENUMS.ITEM, label: ITEM },
	{ value: VIEWBY_ENUMS.BRAND, label: BRAND },
	{ value: VIEWBY_ENUMS.STATE, label: STATE },
	{ value: VIEWBY_ENUMS.STORE, label: STORE },
	{ value: VIEWBY_ENUMS.FINELINE, label: FINELINE },
	{ value: VIEWBY_ENUMS.ALL_LINK_NUMBER, label: ALL_LINK_NUMBER },
	{ value: VIEWBY_ENUMS.PRIME_ITEM_NUMBER, label: PRIME_ITEM_NUMBER },
	{ value: VIEWBY_ENUMS.SUB_DIVISION, label: SUB_DIVISION },
	{ value: VIEWBY_ENUMS.REGION, label: REGION },
	{ value: VIEWBY_ENUMS.MARKET, label: MARKET },
];

const breakDownByOptions_SUBCATEGORY = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
	{ value: VIEWBY_ENUMS.ITEM, label: ITEM },
	{ value: VIEWBY_ENUMS.BRAND, label: BRAND },
	{ value: VIEWBY_ENUMS.ALL_LINK_NUMBER, label: ALL_LINK_NUMBER },
	{ value: VIEWBY_ENUMS.PRIME_ITEM_NUMBER, label: PRIME_ITEM_NUMBER },
];

const breakDownByOptions_store_SUBCATEGORY = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
	{ value: VIEWBY_ENUMS.ITEM, label: ITEM },
	{ value: VIEWBY_ENUMS.BRAND, label: BRAND },
	{ value: VIEWBY_ENUMS.STATE, label: STATE },
	{ value: VIEWBY_ENUMS.STORE, label: STORE },
	{ value: VIEWBY_ENUMS.FINELINE, label: FINELINE },
	{ value: VIEWBY_ENUMS.ALL_LINK_NUMBER, label: ALL_LINK_NUMBER },
	{ value: VIEWBY_ENUMS.PRIME_ITEM_NUMBER, label: PRIME_ITEM_NUMBER },
	{ value: VIEWBY_ENUMS.SUB_DIVISION, label: SUB_DIVISION },
	{ value: VIEWBY_ENUMS.REGION, label: REGION },
	{ value: VIEWBY_ENUMS.MARKET, label: MARKET },
];

const breakDownByOptions_ITEM = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
];

const breakDownByOptions__store_ITEM = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
	{ value: VIEWBY_ENUMS.STATE, label: STATE },
	{ value: VIEWBY_ENUMS.STORE, label: STORE },
	{ value: VIEWBY_ENUMS.SUB_DIVISION, label: SUB_DIVISION },
	{ value: VIEWBY_ENUMS.REGION, label: REGION },
	{ value: VIEWBY_ENUMS.MARKET, label: MARKET },
];

const breakDownByOptions_BRAND = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
	{ value: VIEWBY_ENUMS.CATEGORY, label: CATEGORY },
	{ value: VIEWBY_ENUMS.SUBCATEGORY, label: SUBCATEGORY },
	{ value: VIEWBY_ENUMS.ITEM, label: ITEM },
	{ value: VIEWBY_ENUMS.ALL_LINK_NUMBER, label: ALL_LINK_NUMBER },
	{ value: VIEWBY_ENUMS.PRIME_ITEM_NUMBER, label: PRIME_ITEM_NUMBER },
];

const breakDownByOptions_store_BRAND = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
	{ value: VIEWBY_ENUMS.CATEGORY, label: CATEGORY },
	{ value: VIEWBY_ENUMS.SUBCATEGORY, label: SUBCATEGORY },
	{ value: VIEWBY_ENUMS.ITEM, label: ITEM },
	{ value: VIEWBY_ENUMS.STATE, label: STATE },
	{ value: VIEWBY_ENUMS.STORE, label: STORE },
	{ value: VIEWBY_ENUMS.FINELINE, label: FINELINE },
	{ value: VIEWBY_ENUMS.ALL_LINK_NUMBER, label: ALL_LINK_NUMBER },
	{ value: VIEWBY_ENUMS.PRIME_ITEM_NUMBER, label: PRIME_ITEM_NUMBER },
	{ value: VIEWBY_ENUMS.SUB_DIVISION, label: SUB_DIVISION },
	{ value: VIEWBY_ENUMS.REGION, label: REGION },
	{ value: VIEWBY_ENUMS.MARKET, label: MARKET },
];

const breakDownByOptions_STATE = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
	{ value: VIEWBY_ENUMS.DEPARTMENT, label: DEPARTMENT },
	{ value: VIEWBY_ENUMS.CATEGORY, label: CATEGORY },
	{ value: VIEWBY_ENUMS.SUBCATEGORY, label: SUBCATEGORY },
	{ value: VIEWBY_ENUMS.ITEM, label: ITEM },
	{ value: VIEWBY_ENUMS.BRAND, label: BRAND },
	{ value: VIEWBY_ENUMS.STORE, label: STORE },
	{ value: VIEWBY_ENUMS.FINELINE, label: FINELINE },
];

const breakDownByOptions_STORE = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
	{ value: VIEWBY_ENUMS.DEPARTMENT, label: DEPARTMENT },
	{ value: VIEWBY_ENUMS.CATEGORY, label: CATEGORY },
	{ value: VIEWBY_ENUMS.SUBCATEGORY, label: SUBCATEGORY },
	{ value: VIEWBY_ENUMS.ITEM, label: ITEM },
	{ value: VIEWBY_ENUMS.BRAND, label: BRAND },
	{ value: VIEWBY_ENUMS.FINELINE, label: FINELINE },
	{ value: VIEWBY_ENUMS.PRIME_ITEM_NUMBER, label: PRIME_ITEM_NUMBER },
	{ value: VIEWBY_ENUMS.ALL_LINK_NUMBER, label: ALL_LINK_NUMBER },
];

const breakDownByOptions_store_PRIME_ITEM_NUMBER = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
    { value: VIEWBY_ENUMS.STATE, label: STATE },
    { value: VIEWBY_ENUMS.REGION, label: REGION },
    { value: VIEWBY_ENUMS.MARKET, label: MARKET },
    { value: VIEWBY_ENUMS.SUB_DIVISION, label: SUB_DIVISION },
    { value: VIEWBY_ENUMS.STORE, label: STORE },
    { value: VIEWBY_ENUMS.ITEM, label: ITEM },
];

const breakDownByOptions_store_ALL_LINK_NUMBER = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
    { value: VIEWBY_ENUMS.STATE, label: STATE },
    { value: VIEWBY_ENUMS.REGION, label: REGION },
    { value: VIEWBY_ENUMS.MARKET, label: MARKET },
    { value: VIEWBY_ENUMS.SUB_DIVISION, label: SUB_DIVISION },
    { value: VIEWBY_ENUMS.STORE, label: STORE },
    { value: VIEWBY_ENUMS.ITEM, label: ITEM },
];

const breakDownByOptions_store_REGION = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
	{ value: VIEWBY_ENUMS.MARKET, label: MARKET },
	{ value: VIEWBY_ENUMS.STATE, label: STATE },
	{ value: VIEWBY_ENUMS.DEPARTMENT, label: DEPARTMENT },
	{ value: VIEWBY_ENUMS.CATEGORY, label: CATEGORY },
	{ value: VIEWBY_ENUMS.SUBCATEGORY, label: SUBCATEGORY },
	{ value: VIEWBY_ENUMS.ITEM, label: ITEM },
	{ value: VIEWBY_ENUMS.BRAND, label: BRAND },
	{ value: VIEWBY_ENUMS.STORE, label: STORE },
	{ value: VIEWBY_ENUMS.FINELINE, label: FINELINE },
	{ value: VIEWBY_ENUMS.PRIME_ITEM_NUMBER, label: PRIME_ITEM_NUMBER },
	{ value: VIEWBY_ENUMS.ALL_LINK_NUMBER, label: ALL_LINK_NUMBER },
];

const breakDownByOptions_store_MARKET = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
    { value: VIEWBY_ENUMS.DEPARTMENT, label: DEPARTMENT },
    { value: VIEWBY_ENUMS.CATEGORY, label: CATEGORY },
    { value: VIEWBY_ENUMS.SUBCATEGORY, label: SUBCATEGORY },
    { value: VIEWBY_ENUMS.ITEM, label: ITEM },
    { value: VIEWBY_ENUMS.BRAND, label: BRAND },
    { value: VIEWBY_ENUMS.STORE, label: STORE },
    { value: VIEWBY_ENUMS.STATE, label: STATE },
    { value: VIEWBY_ENUMS.FINELINE, label: FINELINE },
    { value: VIEWBY_ENUMS.PRIME_ITEM_NUMBER, label: PRIME_ITEM_NUMBER },
    { value: VIEWBY_ENUMS.ALL_LINK_NUMBER, label: ALL_LINK_NUMBER },
];

const breakDownByOptions_store_SUB_DIVISION = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
    { value: VIEWBY_ENUMS.REGION, label: REGION },
    { value: VIEWBY_ENUMS.MARKET, label: MARKET },
    { value: VIEWBY_ENUMS.STATE, label: STATE },
    { value: VIEWBY_ENUMS.DEPARTMENT, label: DEPARTMENT },
    { value: VIEWBY_ENUMS.CATEGORY, label: CATEGORY },
    { value: VIEWBY_ENUMS.SUBCATEGORY, label: SUBCATEGORY },
    { value: VIEWBY_ENUMS.ITEM, label: ITEM },
    { value: VIEWBY_ENUMS.BRAND, label: BRAND },
    { value: VIEWBY_ENUMS.STORE, label: STORE },
    { value: VIEWBY_ENUMS.FINELINE, label: FINELINE },
    { value: VIEWBY_ENUMS.PRIME_ITEM_NUMBER, label: PRIME_ITEM_NUMBER },
    { value: VIEWBY_ENUMS.ALL_LINK_NUMBER, label: ALL_LINK_NUMBER },
];

const breakDownByOptions_store_FINELINE = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
	{ value: VIEWBY_ENUMS.BRAND, label: BRAND },
	{ value: VIEWBY_ENUMS.STATE, label: STATE },
	{ value: VIEWBY_ENUMS.REGION, label: REGION },
	{ value: VIEWBY_ENUMS.MARKET, label: MARKET },
	{ value: VIEWBY_ENUMS.SUB_DIVISION, label: SUB_DIVISION },
	{ value: VIEWBY_ENUMS.PRIME_ITEM_NUMBER, label: PRIME_ITEM_NUMBER },
	{ value: VIEWBY_ENUMS.ALL_LINK_NUMBER, label: ALL_LINK_NUMBER },
	{ value: VIEWBY_ENUMS.ITEM, label: ITEM },
];

const customAttributesBreakdownByOptions = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
	{ value: VIEWBY_ENUMS.DEPARTMENT, label: DEPARTMENT },
	{ value: VIEWBY_ENUMS.CATEGORY, label: CATEGORY },
	{ value: VIEWBY_ENUMS.SUBCATEGORY, label: SUBCATEGORY },
	{ value: VIEWBY_ENUMS.ITEM, label: ITEM },
	{ value: VIEWBY_ENUMS.BRAND, label: BRAND },
];

const customAttributesBreakdownByOptions_STORE = [
	{ value: VIEWBY_ENUMS.SET_TO_DEFAULT, label: SET_TO_DEFAULT },
	{ value: VIEWBY_ENUMS.DEPARTMENT, label: DEPARTMENT },
	{ value: VIEWBY_ENUMS.CATEGORY, label: CATEGORY },
	{ value: VIEWBY_ENUMS.STATE, label: STATE },
	{ value: VIEWBY_ENUMS.SUBCATEGORY, label: SUBCATEGORY },
	{ value: VIEWBY_ENUMS.ITEM, label: ITEM },
	{ value: VIEWBY_ENUMS.BRAND, label: BRAND },
	{ value: VIEWBY_ENUMS.STORE, label: STORE },
	{ value: VIEWBY_ENUMS.REGION, label: REGION },
	{ value: VIEWBY_ENUMS.MARKET, label: MARKET },
	{ value: VIEWBY_ENUMS.SUB_DIVISION, label: SUB_DIVISION },
	{ value: VIEWBY_ENUMS.FINELINE, label: FINELINE },
];

export const timePeriodOptions = [
	{
		title: LAST_WMT_WEEK,
		value: TIME_PERIOD_ENUMS.LW,
		label: LAST_WMT_WEEK,
		shortLabel: LAST_WMT_WEEK_SHORT,
		shortValue: 1,
	},
	{
		title: LAST_4_WMT_WEEK,
		value: TIME_PERIOD_ENUMS.L4W,
		label: LAST_4_WMT_WEEK,
		shortLabel: LAST_4_WMT_WEEK_SHORT,
		shortValue: 4,
	},
	{
		title: LAST_13_WMT_WEEK,
		value: TIME_PERIOD_ENUMS.L13W,
		label: LAST_13_WMT_WEEK,
		shortLabel: LAST_13_WMT_WEEK_SHORT,
		shortValue: 13,
	},
	{
		title: LAST_26_WMT_WEEK,
		value: TIME_PERIOD_ENUMS.L26W,
		label: LAST_26_WMT_WEEK,
		shortLabel: LAST_26_WMT_WEEK_SHORT,
		shortValue: 26,
	},
	{
		title: LAST_52_WMT_WEEK,
		value: TIME_PERIOD_ENUMS.L52W,
		label: LAST_52_WMT_WEEK,
		shortLabel: LAST_52_WMT_WEEK_SHORT,
		shortValue: 52,
	},
];

const TableFilters = () => {
	const dispatch = useDispatch();
	const classes = useStyles();
	const tableFiltersStates = useSelector((state) => state.tableReducer);

	const viewByFilter = tableFiltersStates.viewByFilter;
	const breakDownByFilter = tableFiltersStates.breakDownByFilter;
	const timePeriod = tableFiltersStates.timePeriodFilter;
	const newTimePeriodFilter = tableFiltersStates.newTimePeriodFilter;

	const [weekFilterDisabledIndex, setWeekFilterDisabledIndex] = useState(null);
	const [breakDownByOptions, setBreakDownByOptions] = useState(
		breakDownByOptions_DEPARTMENT
	);

	const {
		selectedFilters: { selectedFilter, weekFilter },
	} = useSelector((state) => state.salesReducer);

	const custAttrNames = useSelector(
		(state) => state.tableReducer.custAttrNames
	);

	const [breakDownByCustomAttribues, setBreakDownByCustomAttribues] =
		useState();

	const viewByType = useSelector((state) => state.tableReducer.viewByType);

	const breakDownByType = useSelector(
		(state) => state.tableReducer.breakDownByType
	);

	const selectedView = useSelector(
		(state) => state.appGuideReducer?.selectedView
	);

	const portalUserContext = React.useContext(UserPortalContext);

	const getbreakDownByCustomAttributes = (
		viewByFilter,
		viewByType,
		custAttrNames
	) => {
		if (viewByType === CUSTOM_ATTR) {
			const names = custAttrNames.filter(
				(custAttrName) => viewByFilter != custAttrName?.name
			);
			return names;
		}
		return custAttrNames;
	};

	useEffect(() => {
		const customAttributeNames = getbreakDownByCustomAttributes(
			viewByFilter,
			viewByType,
			custAttrNames
		);
		setBreakDownByCustomAttribues(customAttributeNames);
	}, [viewByFilter, custAttrNames]);

	const handleViewByChange = (value) => {
		dispatch(setViewByFilterAction(value));
		const request = {
			event: 'Change Table Selection - view by filter',
			event_description: `view by filter - ${
				viewByType === CUSTOM_ATTR ? CUSTOM_ATTRIBUTE : WALMART_ATTRIBUTE
			} - ${value}`,
			attributes: MAIN_INSIGHTS_DASHBOARD,
		};
		dispatch(saveEventTrack({ request, portalUserContext }));
		analytics.trackEventInfo({
			type: tracker.EVENTS.CLICK,
			actionOn: 'Change Table Selection - view by filter',
		});
		analytics.trackEventInfo({
			type: tracker.EVENTS.CLICK,
			actionOn: `view by filter -  ${value}`,
		});
	};

	const sortAndDispatch = (value) => {
		// Sort value Array based on the shortValue
		value.sort((a, b) => a.shortValue - b.shortValue);

		dispatch(setTimePeriodAction(value));
		dispatch(setNewTimePeriodAction(value));
	};

	const handleBreakDownByChange = (value) => {
		dispatch(setBreakdownByFilterAction(value));
		const request = {
			event: 'Change Table Selection - breakdown by filter',
			event_description: `breakdown by filter - ${
				breakDownByType === CUSTOM_ATTR ? CUSTOM_ATTRIBUTE : WALMART_ATTRIBUTE
			} - ${value ? value : 'DEFAULT'}; view by filter - ${
				breakDownByType === CUSTOM_ATTR ? CUSTOM_ATTRIBUTE : WALMART_ATTRIBUTE
			} -  ${viewByFilter}`,
			attributes: MAIN_INSIGHTS_DASHBOARD,
		};
		dispatch(saveEventTrack({ request, portalUserContext }));
		analytics.trackEventInfo({
			type: tracker.EVENTS.CLICK,
			actionOn: 'Change Table Selection - breakdown by filter"',
		});
		analytics.trackEventInfo({
			type: tracker.EVENTS.CLICK,
			actionOn: `breakdown by filter - ${
				value ? value : 'DEFAULT'
			}; view by filter - ${viewByFilter}`,
		});
	};

	// Watch any change in global channel filter
	useEffect(() => {
		if (selectedFilter == 'Store') {
			viewByOptions = viewByOptions_store?.map((item) => item);
			// Update breakdown by based on the new 'View by' options
			setBreakDownByOptions(breakDownByOptions_store_DEPARTMENT);
		} else {
			viewByOptions = viewByOptions_omni_ecom?.map((item) => item);
			setBreakDownByOptions(breakDownByOptions_DEPARTMENT);
		}
	}, [selectedFilter]);

	// Watch any change in top page week filter, to disable time period comparison option
	useEffect(() => {
		switch (weekFilter) {
			case 1:
				setWeekFilterDisabledIndex(0);
				break;
			case 4:
				setWeekFilterDisabledIndex(1);
				break;
			case 13:
				setWeekFilterDisabledIndex(2);
				break;
			case 26:
				setWeekFilterDisabledIndex(3);
				break;
			case 52:
				setWeekFilterDisabledIndex(4);
				break;
			default:
				setWeekFilterDisabledIndex(null);
		}
	}, [weekFilter]);

	useEffect(() => {
		// Dispatch new values to Redux state
		dispatch(setViewByFilterAction(viewByFilter));
		dispatch(setBreakdownByFilterAction(breakDownByFilter));

		// Update `Breakdown by` filter whenever the `View by` filter is changed
		onViewByChanges();
	}, [viewByFilter, selectedView]);

	const onViewByChanges = () => {
		if (viewByType === WMT_ATTR) {
			if (selectedFilter != 'Store') {
				switch (viewByFilter) {
					case VIEWBY_ENUMS.DEPARTMENT:
						setBreakDownByOptions(breakDownByOptions_DEPARTMENT);
						break;
					case VIEWBY_ENUMS.CATEGORY:
						setBreakDownByOptions(breakDownByOptions_CATEGORY);
						break;
					case VIEWBY_ENUMS.SUBCATEGORY:
						setBreakDownByOptions(breakDownByOptions_SUBCATEGORY);
						break;
					case VIEWBY_ENUMS.ITEM:
						setBreakDownByOptions(breakDownByOptions_ITEM);
						break;
					case VIEWBY_ENUMS.BRAND:
						setBreakDownByOptions(breakDownByOptions_BRAND);
						break;
					case VIEWBY_ENUMS.ALL_LINK_NUMBER:
						setBreakDownByOptions(breakDownByOptions_ALL_LINK_NUMBER);
						break;
					case VIEWBY_ENUMS.PRIME_ITEM_NUMBER:
						setBreakDownByOptions(breakDownByOptions_PRIME_ITEM_NUMBER);
						break;
					default:
						setBreakDownByOptions(breakDownByOptions_DEPARTMENT);
						break;
				}
			} else {
				switch (viewByFilter) {
					case VIEWBY_ENUMS.DEPARTMENT:
						setBreakDownByOptions(breakDownByOptions_store_DEPARTMENT);
						break;
					case VIEWBY_ENUMS.CATEGORY:
						setBreakDownByOptions(breakDownByOptions_store_CATEGORY);
						break;
					case VIEWBY_ENUMS.SUBCATEGORY:
						setBreakDownByOptions(breakDownByOptions_store_SUBCATEGORY);
						break;
					case VIEWBY_ENUMS.ITEM:
						setBreakDownByOptions(breakDownByOptions__store_ITEM);
						break;
					case VIEWBY_ENUMS.BRAND:
						setBreakDownByOptions(breakDownByOptions_store_BRAND);
						break;
					case VIEWBY_ENUMS.STATE:
						setBreakDownByOptions(breakDownByOptions_STATE);
						break;
					case VIEWBY_ENUMS.STORE:
						setBreakDownByOptions(breakDownByOptions_STORE);
						break;
					case VIEWBY_ENUMS.PRIME_ITEM_NUMBER:
						setBreakDownByOptions(breakDownByOptions_store_PRIME_ITEM_NUMBER);
						break;
					case VIEWBY_ENUMS.ALL_LINK_NUMBER:
						setBreakDownByOptions(breakDownByOptions_store_ALL_LINK_NUMBER);
						break;
					case VIEWBY_ENUMS.REGION:
						setBreakDownByOptions(breakDownByOptions_store_REGION);
						break;
					case VIEWBY_ENUMS.MARKET:
						setBreakDownByOptions(breakDownByOptions_store_MARKET);
						break;
					case VIEWBY_ENUMS.SUB_DIVISION:
						setBreakDownByOptions(breakDownByOptions_store_SUB_DIVISION);
						break;
					case VIEWBY_ENUMS.FINELINE:
						setBreakDownByOptions(breakDownByOptions_store_FINELINE);
						break;
					default:
						setBreakDownByOptions(breakDownByOptions_store_DEPARTMENT);
						break;
				}
			}
		} else if (selectedFilter != 'Store') {
			setBreakDownByOptions(customAttributesBreakdownByOptions);
		} else {
			setBreakDownByOptions(customAttributesBreakdownByOptions_STORE);
		}

		if (breakDownByFilter !== '') {
			dispatch(setBreakdownByFilterAction(''));
		}
	};

	return (
		<ThemeProvider theme={theme}>
			<Box className={classes.container}>
				<Box className={classes.filtersContainer}>
					{/* VIEW BY FILTER */}

					<TableMenu
						wmtOptions={viewByOptions}
						customOptions={custAttrNames}
						label="View By"
						isViewBy={true}
						formId="view-by-filter"
						selectedValue={viewByFilter}
						handleValueChange={handleViewByChange}
						selectedView={selectedView}
					/>

					{/* BREAKDOWN BY FILTER */}

					<TableMenu
						wmtOptions={breakDownByOptions}
						customOptions={breakDownByCustomAttribues}
						label="Breakdown By"
						isViewBy={false}
						formId="breakdown-by-filter"
						selectedValue={breakDownByFilter}
						handleValueChange={handleBreakDownByChange}
						selectedView={selectedView}
					/>

					{/* COMPARISON TIME PERIOD AUTOCOMPLETE */}
					<FormControl className={`${classes.formControl}`} size="small">
						<FormLabel className={classes.label}>
							{COMPARISON_TIME_PERIOD}
						</FormLabel>

						<Autocomplete
							PaperComponent={({ children }) => {
								return (
									<Paper>
										{children}
										<Stack
											direction="row"
											spacing={2}
											justifyContent="flex-end"
											alignItems="center"
											alignContent="flex-end"
											sx={{
												borderTop: '1px solid #f3f3f3',
												padding: '8px !important',
											}}>
											<Button
												data-testid="cancel-comparison-time-period"
												className={classes.cancelBtn}
												onMouseDown={() => {
													dispatch(setNewTimePeriodAction(newTimePeriodFilter));
													dispatch(setTimePeriodAction(newTimePeriodFilter));
												}}>
												Cancel
											</Button>

											<Button
												data-testid="apply-comparison-time-period"
												className={classes.applyBtn}
												onMouseDown={() => {
													sortAndDispatch(timePeriod);

													// Event Tracking
													const timePeriodArr = timePeriod?.map(
														(obj) => obj?.value
													);

													const request = {
														event:
															'Change Table Selection - Comparison time period',
														event_description: JSON.stringify(timePeriodArr),
														attributes: MAIN_INSIGHTS_DASHBOARD,
													};
													dispatch(
														saveEventTrack({ request, portalUserContext })
													);
												}}>
												Apply
											</Button>
										</Stack>
									</Paper>
								);
							}}
							multiple
							clear
							disableCloseOnSelect
							options={timePeriodOptions}
							getOptionDisabled={(option) =>
								option === timePeriodOptions[weekFilterDisabledIndex]
							}
							getOptionLabel={(option) => option.shortLabel}
							id="comparison-time-period-dropdown_autocomplete"
							data-testid="comparison-time-period"
							value={timePeriod}
							onChange={(event, newValue, situation) => {
								if (situation === 'removeOption' || situation === 'clear') {
									dispatch(setNewTimePeriodAction(newValue));
									analytics.trackEventInfo({
										type: tracker.EVENTS.CLICK,
										actionOn:
											'Change Table Selection - Comparison time period-remove timeframe',
									});
									// Event Tracking
									const timePeriodArr = newValue?.map((obj) => obj?.value);
									const request = {
										event: 'Change Table Selection - Comparison time period',
										event_description: JSON.stringify(timePeriodArr),
										attributes: MAIN_INSIGHTS_DASHBOARD,
									};
									dispatch(saveEventTrack({ request, portalUserContext }));
								}
								dispatch(setTimePeriodAction(newValue));
								analytics.trackEventInfo({
									type: tracker.EVENTS.CLICK,
									actionOn: 'Change Table Selection - Comparison time period',
								});
							}}
							renderTags={(tagValue, getTagProps) =>
								tagValue?.map((option, index) => (
									<Chip
										key={index}
										label={option.shortLabel}
										{...getTagProps({ index })}
										deleteIcon={<Clear />}
									/>
								))
							}
							renderOption={(props, option, { selected }) => (
								<li {...props} data-testid={`time-period-${option.value}`}>
									<Checkbox
										disabled
										icon={icon}
										checkedIcon={checkedIcon}
										checked={selected}
										sx={{
											color: selected && `${PURPLE} !important`,
											padding: '10px !important',
										}}
									/>
									{option.title}
								</li>
							)}
							sx={{ width: 300 }}
							renderInput={(params) => (
								<TextField
									{...params}
									placeholder={
										timePeriod?.length === 0 ? SELECT_ONE_OR_MULTIPLE : ''
									}
								/>
							)}
							className={classes.autcomplete}></Autocomplete>
					</FormControl>
				</Box>
				<Box>
					<CustomTableColumn />
				</Box>
			</Box>
		</ThemeProvider>
	);
};

export default TableFilters;
